import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import { PostHogProvider } from "@/components/providers/PostHogProvider";
import "./index.css";

// Global "Chunk Load Error" auto-healer for new deployments
if (typeof window !== "undefined") {
  const handleChunkError = (err: string) => {
    const message = err?.toLowerCase?.() || "";
    if (
      message.includes("failed to fetch dynamically imported module") ||
      message.includes("error loading dynamically imported module") ||
      message.includes("importing a module script failed") ||
      message.includes("loading chunk") ||
      message.includes("dynamically imported module")
    ) {
      console.warn("[Athr] Stale build detected. Auto-reloading to fetch newest deployment...");
      // Avoid immediate tight loops if refresh fails; give it 300ms
      setTimeout(() => window.location.reload(), 300);
    }
  };

  window.addEventListener("error", (e) => handleChunkError(e.message));
  window.addEventListener("unhandledrejection", (e) => {
    if (e.reason instanceof Error) handleChunkError(e.reason.message);
    else handleChunkError(String(e.reason));
  });
}

if (import.meta.env.DEV && "serviceWorker" in navigator) {
  void navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      void registration.unregister();
    });
  });
  if ("caches" in window) {
    void caches.keys().then((keys) => {
      keys.forEach((key) => {
        void caches.delete(key);
      });
    });
  }
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <PostHogProvider>
      <App />
    </PostHogProvider>
  </HelmetProvider>
);
